import CurrentSurgery from 'presentation/contexts/current-surgery/current-surgery-context'

export default function makeCurrentSurgery() {
  return new CurrentSurgery()
}
